export const getPromptByTone = (tone: string) => {
	return `Use language models to identify and analyze the tone of the text.
Suggest modifications to create ${tone} tone for the text. Text:`;
};
